//fixes price to display as 16.00 instead of 1600, price is currently being saved as 1600 in the database
export const fixPrice = (price: number) => {
  return (price / 100).toFixed(2);
};
